'use client'

import dynamic from 'next/dynamic'

/**
 * Player Lottie carregado apenas no cliente.
 * A lib `@lottiefiles/react-lottie-player` (lottie-web) acessa `document`
 * na inicialização do módulo e quebra o prerender/SSR do Next.js.
 */
export const LottiePlayer = dynamic(
  () => import('@lottiefiles/react-lottie-player').then((mod) => mod.Player),
  { ssr: false }
)
